__turbopack_context__.v({
  "filterToggleBtn": "AddOnSearchBar-module-scss-module__VyyS1G__filterToggleBtn",
  "filterToggleIcon": "AddOnSearchBar-module-scss-module__VyyS1G__filterToggleIcon",
  "searchButton": "AddOnSearchBar-module-scss-module__VyyS1G__searchButton",
  "searchForm": "AddOnSearchBar-module-scss-module__VyyS1G__searchForm",
  "searchInput": "AddOnSearchBar-module-scss-module__VyyS1G__searchInput",
  "searchWrapper": "AddOnSearchBar-module-scss-module__VyyS1G__searchWrapper",
});
